import React, { useEffect, useState } from "react";
import {
  CrossIcon,
  TableSortIconDownArrow,
} from "../../utils/icons/defaultIcons";
import FadeIn from "react-fade-in";
import ComponentMap from "../../atom/componentmap";
import ThemedButton from "../../atom/ThemedButton/themedButton";
import Table from "../../atom/table";
import * as loaderLottie from "../../utils/lottie/loaderLottie.json";
import { useNavigate } from "react-router-dom";
import {
  get_Dcid_Plan,
  getAllNpaNumbers,
  getAllNpas,
  getAllRateCenters,
  getAllStates,
  getAppServerTenants,
  purchaseDIDS,
} from "../../services/api";
import Notification from "../../atom/Notification";
import { addChildrensToMapData } from "../../services/utilities";
import Lottiefy from "../../atom/lottie/lottie";
import Modal from "../../atom/modal";
import { da } from "date-fns/locale";

function PurchaseDidModal() {
  const navigate = useNavigate();
  const [didTable, setDIdTable] = useState<boolean>(false);
  const [resultNotFound, setResultNotFound] = useState<boolean>(false);
  const [tableLoader, setTableLoader] = useState<boolean>(false);
  const [buttonLoader, setButtonLoader] = useState<boolean>(false);
  const [tenantListModal, setTenantListModal] = useState<boolean>(false);
  const [showTenants, setShowTenants] = useState<boolean>(false);
  const [assignServiceModal, setAssignServiceModal] = useState<boolean>(false);
  const [dcidModal, setDcidModal] = useState<boolean>(false);

  const [serviceDropdown, setServiceDropdown] = useState<any>([
    {
      title: "Assign Service",
      name: "assigned_to",
      value: "",
      type: "dropdown",
      displayProps: { label: "label", value: "value" },
      childrens: [
        { label: "Unassign", value: "Unassign" },
        { label: "Silhouette", value: "Silhouette" },
        { label: "DCID", value: "DCID" },
      ],
    },
  ]);
  const handleCallback = (data: any, key: string) => {
    console.log("callback", data, "key", key);
    if (key === "state") {
      getRateCenter(data?.state_code);
      getNpa(undefined, data?.state_code);
    } else if (key === "rate_center") {
      getNpa(data?.rate_center);
    } else if (key === "npa") {
      fetchTenantsList();
    }
  };

  const [didData, setDidData] = useState<any>([
    {
      title: "Select State",
      name: "state",
      value: "",
      disabled: false,
      type: "multiselectdropdown",
      displayProps: {
        label: "state",
        value: "state",
      },
      Callback: handleCallback,
      childrens: [],
      required: true,
      errormessage: "Select a State",
    },
    {
      name: "rate_center",
      title: "Rate Center",
      displayProps: {
        label: "rate_center",
        value: "rate_center",
      },
      type: "multiselectdropdown",
      Callback: handleCallback,
      childrens: [],
      required: false,
      value: "",
      errormessage: "Please select a rate center",
    },
    {
      name: "npa",
      title: "NPA",
      displayProps: {
        label: "npa",
        value: "npa",
      },
      childrens: [],
      type: "multiselectdropdown",
      // Callback: handleCallback,
      required: true,
      value: "",
      errormessage: "Please select NPA",
    },
    // {
    //   name: "uuid",
    //   title: "Tenant",
    //   displayProps: {
    //     label: "displayname",
    //     value: "uuid",
    //   },
    //   childrens: [],
    //   type: "multiselectdropdown",
    //   required: false,
    //   value: "",
    //   errormessage: "Please select a tenant",
    // },
  ]);

  const [tableTitles, setTableTitles] = useState<any>([
    {
      key: "did",
      title: "Number",
      icon: <TableSortIconDownArrow />,
      sort: { direction: "asc", active: true },
    },

    {
      key: "carrier",
      title: "Carrier",
      icon: <TableSortIconDownArrow />,
      sort: { direction: "asc", active: false },
    },

    {
      key: "",
      type: "checkbox",
      classname: "float-right ",
      selectAll: true,
    },
  ]);

  const [tableData, setTableData] = useState<any>([]);

  const [tenantList, setTenantList] = useState<any>([
    {
      title: "Select a tenant",
      name: "displayname",
      value: "",
      type: "multiselectdropdown",
      displayProps: {
        label: "displayname",
        value: "displayname",
      },
      childrens: [],
      required: false,
      errormessage: "Select a tenant",
    },
  ]);

  const [dcidDropdown, setDcidDropdown] = useState<any>([
    {
      title: "Select DCID",
      name: "name",
      value: "",
      disabled: false,
      type: "multiselectdropdown",
      displayProps: {
        label: "name",
        value: "name",
      },
      childrens: [],
      required: false,
      hidden: false,
      errormessage: "Select DCID",
    },
  ]);

  const getRateCenter = (state_code: string) => {
    if (!state_code) {
      setDidData((prev: any) => {
        const newData = addChildrensToMapData([...prev], [], "rate_center");
        return newData.map((item: any) =>
          item.name === "rate_center" ? { ...item, value: "" } : item,
        );
      });
      return;
    }
    getAllRateCenters(state_code).then((result: any) => {
      if (!result.success) {
        Notification(
          "Failed",
          `${
            result?.message ? result?.message : "Couldn't find any Rate Centers"
          }`,
          "danger",
        );
      } else {
        setDidData((prev: any) =>
          addChildrensToMapData([...prev], result?.data?.items, "rate_center"),
        );
      }
    });
  };

  const getNpa = (rate_center: any, stateCode?: string) => {
    const state_values = didData.find((item: any) => {
      return item?.name === "state";
    });
    const state_code = stateCode || state_values?.value?.state_code;

    if (!state_code) {
      setDidData((prev: any) => {
        const newData = addChildrensToMapData([...prev], [], "npa");
        return newData.map((item: any) =>
          item.name === "npa" ? { ...item, value: "" } : item,
        );
      });
      return;
    }

    getAllNpas(state_code, rate_center).then((result: any) => {
      if (!result.success) {
        Notification(
          "Failed",
          `${result?.message ? result?.message : "Couldn't find any NPA "}`,
          "danger",
        );
      } else {
        setDidData((prev: any) =>
          addChildrensToMapData([...prev], result?.data?.items, "npa"),
        );
      }
    });
  };

  const getStates = () => {
    getAllStates().then((result: any) => {
      if (!result.success) {
        Notification(
          "Failed",
          `${result?.message ? result?.message : "Couldn't find any states"}`,
          "danger",
        );
      } else {
        setDidData((prev: any) =>
          addChildrensToMapData([...prev], result?.data?.items, "state"),
        );
      }
    });
  };

  const fetchTenantsList = () => {
    getAppServerTenants("").then((result: any) => {
      console.log("result", result);
      if (!result.success) {
        Notification(
          "Failed",
          `${result?.message ? result?.message : "Oops! Something went wrong"}`,
          "danger",
        );
      } else {
        setTenantList(
          addChildrensToMapData([...tenantList], result?.data, "displayname"),
        );
      }
    });
  };

  const onHandleDidSearch = (result: any) => {
    setDIdTable(true);
    setTableLoader(true);
    const payload = {
      state_code: result?.state?.state_code,
      rate_center_abbr: result?.rate_center?.rate_center_abbr,
      npa: result?.npa?.npa,
      hide_unassigned: true,
    };
    getAllNpaNumbers(
      payload.state_code,
      payload.rate_center_abbr,
      payload.npa,
      payload.hide_unassigned,
    ).then((result: any) => {
      const data = result?.data?.items;
      if (!result.success || data?.length === 0) {
        setTableLoader(false);
        setResultNotFound(true);
      } else {
        setResultNotFound(false);
        setTableLoader(false);
      }
      setTableData(data);
    });
  };

  const onHandlePurchase = (data?: any) => {
    console.log("data", data);
    if (data?.name === "") {
      Notification("Required", "Select any DCID", "danger");
      return;
    }

    if (data?.displayname === "" || data?.displayname === null) {
      // Notification("Failed", `Select a Tenant`, "danger");
      return;
    }
    // return;

    if (tableData[0].length !== 0) {
      setButtonLoader(true);
      const tableDataCopy = [...tableData];
      console.log("tabledata", tableDataCopy);
      const filterchecked = tableDataCopy.filter((node: any) => {
        return node?.checked;
      });

      if (!tenantListModal) {
        setTenantListModal(true);
        setButtonLoader(false);
        return;
      }
      const filteredNumbers = filterchecked.map((item: any) => ({
        did: item.did,
        carrier: item.carrier,
        unassigned: item.unassigned,
      }));

      const payload: any = {
        numbers: filteredNumbers,
      };

      if (tableData[0]?.npa_id !== "undefined") {
        payload.npa_id = tableData[0]?.npa_id;
      }

      if (tenantList[0]?.value?.uuid) {
        payload.tenant_id = tenantList[0]?.value?.uuid;
      }

      if (data?.assigned_to === "Silhouette") {
        console.log("dcidDropdown", dcidDropdown, "dataa", data);
        payload.assigned_to = data?.assigned_to;
      }

      if (dcidModal) {
        console.log("reached dcidmodal", data);
        payload.assigned_to = "DCID";
        payload.dcid_id = data?.name?.uuid;
      }
      console.log("payload", payload);

      purchaseDIDS(payload).then((result: any) => {
        if (!result.success) {
          Notification(
            "Failed",
            `${
              result?.message
                ? result?.message
                : "Oops! Something went wrong. Please try again later"
            }`,
            "danger",
          );
          setButtonLoader(false);
        } else {
          Notification("Success", "Number purchased successfully", "success");
          setButtonLoader(false);
          navigate(-1);
        }
      });
    }
  };

  const onClickPurchase = () => {
    const tableDataCopy = [...tableData];
    const filterchecked = tableDataCopy.filter((node: any) => {
      return node?.checked;
    });

    if (filterchecked.length === 0) {
      Notification(
        "Failed",
        `Select at least one number to purchase`,
        "danger",
      );

      setButtonLoader(false);
      return;
    }
    setTenantListModal(true);
  };

  const onCloseModal = () => {
    navigate(-1);
  };

  const selectCheckbox = (action: any, data: any) => {
    console.log("checboxdata", data);
    const clone = [...tableData];
    const ttile = [...tableTitles];
    if (data?.selectAll === true) {
      const result: any = ttile.find((node: any) => {
        return node.key === data.key;
      });

      result.checked = !result?.checked || false;
      clone.map((node: any) => {
        node.checked = result?.checked;
      });
    } else {
      const result = clone.find((node: any) => {
        return node.did === data.did;
      });
      result.checked = !result?.checked || false;
    }
    const result = clone.find((node: any) => {
      return node?.checked ? node?.checked : false;
    });

    setTableTitles(ttile);
    setTableData(clone);
  };

  const onHandleCancel = () => {
    setShowTenants(false);
    setTenantList((prev: any) =>
      prev.map((item: any) => ({ ...item, value: "" })),
    );
  };

  const onHandleAssignTenant = (data?: any) => {
    if (data?.displayname === "" || data?.displayname === null) {
      Notification("Failed", `Select a Tenant`, "danger");
      return;
    } else {
      setAssignServiceModal(true);
    }
  };

  const onHandleCloseServiceModal = () => {
    setAssignServiceModal(false);
    setServiceDropdown((prev: any) =>
      prev.map((item: any) => ({ ...item, value: "" })),
    );
  };

  const onHandleCompletePurchase = (data?: any) => {
    console.log("dataaa", data);

    if (data?.assigned_to === "") {
      Notification("Required", "Select any service", "danger");
    }
    if (
      data?.assigned_to === "Silhouette" ||
      data?.assigned_to === "Unassign"
    ) {
      onHandlePurchase(data);
    }
    if (data?.assigned_to === "DCID") {
      setDcidModal(true);
      getDcidData();
    }
  };

  const getDcidData = () => {
    setDcidModal(true);
    const tenant_id = tenantList[0]?.value?.uuid;
    get_Dcid_Plan(tenant_id).then((result: any) => {
      if (!result?.success) {
        Notification(
          "Failed",
          `${result?.message ? result?.message : "Oops! Something went wrong"}`,
          "danger",
        );
      } else {
        console.log("result", result?.data?.items);
        setDcidDropdown(
          addChildrensToMapData([...dcidDropdown], result?.data?.items, "name"),
        );
      }
    });
  };

  const actionHandler = (action: string, data: any, index: number) => {
    console.log("action", action);
    const actionsMap: any = {
      selectall: selectCheckbox,
      change: selectCheckbox,
    };
    const act = actionsMap[action];
    if (act) {
      act(action, data);
    } else {
      console.log("actionHandler Error");
    }
  };

  useEffect(() => {
    getStates();
  }, []);

  return (
    <div
      className={`h-[calc(100vh-125px)] basis-[35%] bg-[#fff] relative rounded-md mx-2.5`}
    >
      {tenantListModal && (
        <Modal
          title="Select Tenant"
          onClose={() => setTenantListModal(false)}
          closeEvent={() => setTenantListModal(false)}
        >
          <div className="md:w-[500px] p-2">
            <FadeIn>
              <p>Do you want to assign the selected DIDs to a tenant?</p>
              <div className="text-right w-full mt-8 ">
                <ThemedButton
                  children={"No, Continue"}
                  icon="custom"
                  theme="secondary"
                  loading={buttonLoader}
                  click={() => {
                    setTenantListModal(false);
                    onHandlePurchase();
                  }}
                />
                <ThemedButton
                  children={"Yes, Select Tenant"}
                  icon="custom"
                  theme="primary"
                  loading={buttonLoader}
                  click={() => {
                    setShowTenants(true);
                    fetchTenantsList();
                  }}
                />
              </div>
            </FadeIn>
          </div>
        </Modal>
      )}

      {showTenants && (
        <Modal
          title="Select Tenant"
          onClose={() => setShowTenants(false)}
          closeEvent={() => setShowTenants(false)}
        >
          <div className="md:w-[500px] p-2">
            <FadeIn>
              <ComponentMap data={tenantList} setData={setTenantList} />

              <div className=" h-full py-4 flex  mt-4 float-right">
                <ThemedButton
                  children={"Cancel"}
                  icon="custom"
                  theme="secondary"
                  // valiData={callReport}
                  // change={setCallReport}
                  click={() => {
                    onHandleCancel();
                  }}
                />
                <ThemedButton
                  children={"Assign & Continue"}
                  icon="custom"
                  theme="primary"
                  // click={onHandlePurchase}
                  click={onHandleAssignTenant}
                  valiData={tenantList}
                  change={setTenantList}
                  loading={buttonLoader}
                />
              </div>
            </FadeIn>
          </div>
        </Modal>
      )}
      <div className="flex justify-between p-4 mt-4">
        <b>Buy DIDs</b>
        <p className="cursor-pointer" onClick={onCloseModal}>
          <CrossIcon />
        </p>
      </div>

      <FadeIn>
        <div className="p-2 pt-4">
          <ComponentMap data={didData} setData={setDidData} />
        </div>
        <div className="text-right w-full pr-2">
          <ThemedButton
            children={"Search"}
            icon="custom"
            theme="primary"
            valiData={didData}
            change={setDidData}
            click={onHandleDidSearch}
          />
        </div>
      </FadeIn>
      {didTable && (
        <>
          {tableLoader ? (
            <div className="h-[300px] w-[450px] flex justify-center items-center mt-10">
              <Lottiefy
                loop={true}
                json={loaderLottie}
                height={60}
                width={60}
              />
            </div>
          ) : (
            <>
              <FadeIn>
                <Table
                  tableTitles={tableTitles}
                  tableData={tableData}
                  setTableData={setTableData}
                  setTableTitles={setTableTitles}
                  button={true}
                  buttonIndex={4}
                  buttonText1={"manage"}
                  width={"w-auto overflow-auto"}
                  scrollHeight={"h-[calc(100vh-580px)]  overflow-y-auto"}
                  permission={"provision.users.put"}
                  actions={true}
                  actionHandler={actionHandler}
                  resultNotFound={resultNotFound}
                />
              </FadeIn>

              <div className="text-right  w-full absolute bottom-0 p-2 pb-4">
                <ThemedButton
                  children={"Cancel"}
                  icon="custom"
                  theme="secondary"
                  click={onCloseModal}
                />
                <ThemedButton
                  children={"Purchase"}
                  icon="custom"
                  theme="primary"
                  disabled={tableData?.length === 0 || resultNotFound}
                  loading={buttonLoader}
                  click={onClickPurchase}
                />
              </div>
            </>
          )}
        </>
      )}

      {assignServiceModal && (
        <Modal
          title="Assign Service"
          onClose={() => onHandleCloseServiceModal}
          closeEvent={() => onHandleCloseServiceModal()}
        >
          <div className="md:w-[500px] p-2">
            <FadeIn>
              <ComponentMap
                data={serviceDropdown}
                setData={setServiceDropdown}
              />

              <div className=" h-full py-4 flex  mt-4 float-right">
                <ThemedButton
                  children={"Cancel"}
                  icon="custom"
                  theme="secondary"
                  // valiData={callReport}
                  // change={setCallReport}
                  click={() => {
                    onHandleCloseServiceModal();
                  }}
                />
                <ThemedButton
                  children={"Assign"}
                  icon="custom"
                  theme="primary"
                  click={onHandleCompletePurchase}
                  valiData={serviceDropdown}
                  change={setServiceDropdown}
                  loading={buttonLoader}
                />
              </div>
            </FadeIn>
          </div>
        </Modal>
      )}

      {dcidModal && (
        <Modal
          title="DCID"
          onClose={() => setDcidModal(false)}
          closeEvent={() => setDcidModal(false)}
        >
          <div className="md:w-[500px] p-2">
            <FadeIn>
              <ComponentMap data={dcidDropdown} setData={setDcidDropdown} />

              <div className=" h-full py-4 flex  mt-4 float-right">
                <ThemedButton
                  children={"Cancel"}
                  icon="custom"
                  theme="secondary"
                  // valiData={callReport}
                  // change={setCallReport}
                  click={() => {
                    setDcidModal(false);
                  }}
                />
                <ThemedButton
                  children={"Assign"}
                  icon="custom"
                  theme="primary"
                  click={onHandlePurchase}
                  valiData={dcidDropdown}
                  change={setDcidDropdown}
                  loading={buttonLoader}
                />
              </div>
            </FadeIn>
          </div>
        </Modal>
      )}
    </div>
  );
}

export default PurchaseDidModal;
